import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Close } from "@material-ui/icons";
import { WarningPopover } from "./warning-popover";


export const CloseDrawer = ({ onClose, formikRef, customComponent }) => {
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const { t } = useTranslation();

    const handleContinue = () => {
        setPopoverOpen(false);
        onClose();
    };

    const handleClose = (e) => {
        if (formikRef?.current?.dirty) {
            setPopoverAnchor(e.currentTarget)
            setPopoverOpen(true);
        } else {
            onClose();
        }
    };


    return (
        <>
            {customComponent ? customComponent?.(handleClose) : <Close className="pointer" onClick={handleClose} />}
            <WarningPopover
                onClose={() => {
                    setPopoverOpen(false);
                }}
                onContinue={handleContinue}
                popoverAnchor={popoverAnchor}
                popoverOpen={popoverOpen}
                title={t("CANTEEN.CHANGES_DETECTED")}
                description={t("CANTEEN.CHANGES_DETECTED_DESC")}
            />
        </>
    )
}